var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalTerms',{ref:"modal",attrs:{"gtc":_vm.gtc,"checkbox-text":_vm.checkboxText,"is-creating":_vm.isCreating},on:{"accept":_vm.accept}})
}
var staticRenderFns = []

export { render, staticRenderFns }